export default {
  "Your order has been shipped": "Votre commande a été expédiée",
  "Parcel #": "Colis n°{index}",
  "header": {
    "searchbar": {
      "placeholder": "Rechercher"
    },
    "quickOrder": {
      "title": "Commande rapide"
    },
    "account": {
      "anonymous": {
        "title": "Connexion"
      },
      "connected": {
        "title": "Mon compte"
      }
    },
    "cart": {
      "title": "Mon panier"
    },
    "help": {
      "title": "Aide"
    },
    "seller": {
      "title": "Vendre"
    },
    "menu": {
      "products": "Produits",
      "sellers": "Prestataires",
      "promotions": "Promos",
      "contact": "Contact"
    }
  },
  "footer": {
    "description": "Proin vel lobortis orci, in volutpat ex. Nam a ante at neque tempor finibus nec nec dui. Praesent mollis auctor lectus quis lobortis. Ut tempus, tellus id vulputate finibus, ante diam ullamcorper magna, eget lacinia dolor lorem ac felis. Duis eleifend auctor consequat. Curabitur placerat lacus in sem congue",
    "menu": {
      "columns": {
        "about": "À propos",
        "customer-service": "Service client",
        "information": "Informations",
        "social": {
          "title": "Contact",
          "contact": {
            "form": "Formulaire de contact",
            "email": "Email : {0}",
            "tel": "Téléphone : {0}",
          }
        }
      }
    }
  },
  "cms": {
    "about-us": "Qui sommes-nous ?",
    "become-seller": "Devenir vendeur",
    "become-supplier": "Devenir fournisseur",
    "press-contact": "Contact presse",
    "guaranties": "Garanties",
    "payment-methods": "Moyens de paiement",
    "payment-security": "Sécurité de paiement",
    "shipping": "Livraisons et expéditions",
    "returns": "Conditions de retours et de remboursements",
    "recruitment": "Recrutement",
    "customer-support": "Service client",
    "buying-guide": "Guide d'achat",
    "contact": "Contact",
    "contact-us": "Contactez-nous",
    "my-orders": "Mes commandes",
    "general-terms": "Conditions générales de vente",
    "selling-terms": "Conditions générales de ventes",
    "usage-terms": "Conditions générales d'utilisation",
    "legal-notices": "Mentions légales",
    "privacy-policy": "Politique de protection des données personnelles",
    "return-policy": "Politique de retours",
    "cookies-management": "Gestion des cookies"
  },
  "form": {
    "contact": {
      "title": "Un problème avec votre commande ?",
      "submit": "Envoyer",
      "clear": "Effacer",
      "notifications": {
        "success": "Votre message a bien été envoyé. Nous reviendrons vers vous dans les plus brefs délais."
      }
    },
    "resetPassword": {
      "submit": "Mettre à jour"
    },
    "newsletter": {
      "title": "S'inscrire à la newsletter",
      "description": "Pour recevoir nos actualités & nos promotions.",
      "submit:": "ok"
    },
    "account": {
      "twoFactor": {
        "title": "Activer la double authentification",
        "description": "Pour un accès plus sécurisé de votre compte (envoi d'un code de confirmation par mail).",
        "submit": "Valider le code"
      },
      "forgotPassword": {
        "title": "Mot de passe oublié",
        "description": "Indiquez votre adresse email pour recevoir un lien pour réinitialiser votre mot de passe.",
        "submit": "Réinitialiser mon mot de passe",
        "connect": "Me connecter"
      },
      "login": {
        "title": "Connexion",
        "description": "",
        "submit": "Me connecter",
        "forgot": "Mot de passe oublié ?"
      },
      "signin": {
        "title": "Nouveau compte",
        "description": "",
        "submit": "Me connecter",
        "forgot": "Mot de passe oublié ?",
        "newsletterToggle": "<strong>S'inscrire à la newsletter</strong> (pour recevoir nos actualités & nos promotions)",
        "authToggle": "<strong>Activer la double authentification</strong> (pour mieux sécuriser votre compte)",
        "cgv": {
          "agree": "J'accepte",
          "toTerms": "les conditions générales de vente"
        }
      },
      "address": {
        "submitNew": "Ajouter l'adresse",
        "saveChange": "Sauvegarder les modifications",
        "defaultBilling": "Définir comme adresse de facturation par défaut",
        "defaultShipping": "Définir comme adresse de livraison par défaut"
      },
      "passwordChange": {
        "title": "Modifier le mot de passe",
        "notifications": {
          "success": "Le nouveau mot de passe à bien été enregistré !",
          "error": "Le nouveau mot de passe n'a pas été enregistré, merci de vérifier vos données ou de nous contacter si le problème persiste."
        },
        "submit": "Valider"
      },
      "profilUpdate": {
        "title": "Modifier le mot de passe",
        "notification": {
          "success": "Les informations du compte ont bien été enregistrées !",
          "error": "Les informations du compte n'ont pas été enregistrées !, merci de vérifier vos données ou de nous contacter si le problème persiste"
        },
        "locale": "Choisissez la langue pour les emails de notifications",
        "newsLetterSubscribed": "Inscription à la newsletter",
        "twoFactorAuthenticationEnabled": "Activer la sécurité de votre compte à 2 facteurs",
        "twoFactor": {
          "title": "Activer la double authentification",
          "description": "Pour un accès plus sécurisé de votre compte (envoi d'un code de confirmation par mail)."
        },
        "newsletter": {
          "title": "S'inscrire à la newsletter",
          "description": "Pour recevoir nos actualités & nos promotions."
        },
        "submit": "Valider"
      }
    },
    "orderRef": {
      "other": "Autre référence"
    },
    "label": {
      "orderRef": "Référence de la commande",
      "subject": "Sujet",
      "message": "Message",
      "email": "Email",
      "lastName": "Nom",
      "firstName": "Prénom",
      "password": "Mot de passe",
      "newPassword": "Nouveau mot de passe",
      "repeatPassword": "Répéter le mot de passe",
      "birthDate": "Date de naissance",
      "street": "Rue",
      "postCode": "Code postal",
      "phone": "Téléphone",
      "country": "Pays",
      "city": "Ville",
      "company": "Société"
    },
    "placeholder": {
      "message": "Ecrire un message",
      "country": "Sélectionner un pays"
    },
    "notices": {
      "password": "Le mot de passe doit contenir au moins huit caractères, une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial (caractères autorisés : @$!%*?&)."
    },
    "errors": {
      "message": "Le message doit contenir entre 10 et 400 caractères",
      "email": "Merci de saisir une adresse email valide",
      "firstName": "Votre prénom ne semble pas être correct",
      "lastName": "Votre nom ne semble pas être correct",
      "password": "Mot de passe invalide. Vérifiez les caractères obligatoires et/ou autorisés.",
      "newPassword": "Mot de passe invalide. Vérifiez les caractères obligatoires et/ou autorisés.",
      "repeatPassword": "les mots de passe ne correspondent pas",
      "birthDate": "date de naissance invalide",
      "street": "Adresse non valide",
      "postCode": "Le code postal n'est pas valide",
      "phone": "Veuillez renseigner un numéro de téléphone valide",
      "country": "Veuillez renseigner un pays",
      "city": "Ville non valide"
    },
    "required": {
      "email": "Email requis",
      "firstName": "obligatoire",
      "lastName": "obligatoire",
      "password": "obligatoire",
      "newPassword": "obligatoire",
      "repeatPassword": "obligatoire",
      "birthDate": "obligatoire",
      "street": "obligatoire",
      "postCode": "obligatoire",
      "phone": "obligatoire",
      "country": "obligatoire",
      "city": "obligatoire"
    }
  },
  "Cookie consent": "Gestion des cookies",
  "cookie": {
    "googleAnalytic": {
      "description": "Utilisation: Ces cookies collectent des données statistiques de fréquentation du site afin d’optimiser son ergonomie, sa navigation et ses contenus. ",
      "title": "Google Analytics : mesure d’audience et d’utilisation du site"
    },
    "googleTag": {
      "description": "Utilisation: Ces cookies collectent des données statistiques de fréquentation du site afin d’optimiser son ergonomie, sa navigation et ses contenus. ",
      "title": "Google Tag Manager : mesure d’audience et d’utilisation du site"
    },
    "brevo": {
      "description": "Utilisation: Ces cookies collectent des données statistiques de fréquentation du site afin d’optimiser son ergonomie, sa navigation et ses contenus. ",
      "title": "Brevo : mesure d’audience et d’utilisation du site"
    },
    "internalTracker": {
      "description": "Utilisation: Ces cookies permettent au site de fonctionner de manière optimale. Si vous les supprimez, certaines fonctionnalités du site seront dégradées.",
      "title": "Cookies techniques nécessaires au bon fonctionnement du site"
    },
    "learnMore": "Configurer mes préférences",
    "notice": {
      "description": "@SITE_NAME@ utilise des cookies fonctionnels et analytiques pour permettre le bon fonctionnement de ce site et vous offrir la meilleure expérience possible. Si vous utilisez ce site, des cookies fonctionnels et analytiques vont être installés sur votre navigateur.\nAvec votre consentement, nous utilisons également des cookies marketing pour analyser nos performances marketing et personnaliser les offres présentées dans nos publicités. En utilisant ces cookies, @SITE_NAME@ et des tiers peuvent suivre votre comportement sur internet pour vous proposer du contenu et des publicités en lien avec vos centres d'intérêt.\nEn cliquant sur Accepter, vous consentez à l'utilisation de tous les cookies marketing. Si vous cliquez sur Refuser, nous n'utiliserons aucun cookie marketing. Vous pouvez modifier les paramètres des cookies ou retirer votre consentement à tout moment."
    },
    "noticeModal": {
      "description": "Des cookies et autres traceurs sont utilisés pour les finalités détaillées ci-après pour lesquelles vous pouvez paramétrer vos choix.",
      "title": "Gestion des cookies"
    },
    "pageTitle": "Gestion des cookies",
    "privacy": "Pour en savoir plus sur le fonctionnement des cookies, consultez la page de {privacyPolicy}",
    "social": {
      "description": "Utilisation: Ces cookies permettent d’afficher dans le site des flux d’informations ou d’échanges provenant des réseaux sociaux. ",
      "title": "Réseaux sociaux"
    }
  },
  "adyen": {
    "errorCode10": "La banque de l'acheteur n'accepte pas cette transaction",
    "errorCode11": "Echec 3D Secure",
    "errorCode12": "Pas assez de fonds sur la carte pour honorer la commande",
    "errorCode14": "Fraud possible",
    "errorCode15": "Transaction annulée",
    "errorCode16": "L'acheteur a annulé la transaction avant son terme",
    "errorCode17": "code PIN invalide",
    "errorCode18": "Plus de 3 erreurs sur le code PIN",
    "errorCode19": "Impossible de valider le code PIN",
    "errorCode2": "Transaction refusée",
    "errorCode20": "Risque de fraude élevée, transaction refusée",
    "errorCode21": "La transaction n'a pas fonctionné correctement",
    "errorCode22": "Risque de fraude élevée, transaction refusée",
    "errorCode23": "Code erreur : 57: Transaction non autorisée pour le porteur de carte: Transaction non autorisée pour ce marchand: Transaction non autorisée pour l'acquéreur / terminal",
    "errorCode24": "Code CVC invalide",
    "errorCode25": "Code erreur : 62: Carte restreinte : carte invalide pour ce pays",
    "errorCode26": "L'acheteur a interompu la transaction. Code erreur : \n\"R1: Revocation de la commande en cours\"\n\"R3: Revocation de toutes les commandes\"\n\"R0: Stop Paiement Commande",
    "errorCode27": "This response maps all those response codes that cannot be reliably mapped. This makes it easier to tell generic declines (for example, Mastercard : Do not honor response) from more specific ones",
    "errorCode28": "Le montant de la transaction est supérieur au montant autorisé par la banque pour l'acheteur",
    "errorCode29": "Le nombre de retraits autorisés par la banque pour l'acheteur est dépassé",
    "errorCode3": "Références",
    "errorCode31": "Suspicion de fraude par la banque",
    "errorCode32": "L'adresse de l'acheteur est invalide",
    "errorCode33": "La banque de l'acheteur demande à l'acheteur de saisir son code PIN en ligne",
    "errorCode34": "La banque de l'acheteur demande une vérification du montant pour finaliser la transaction",
    "errorCode35": "La banque de l'acheteur demande un compte pour finaliser la transaction",
    "errorCode36": "La banque de l'acheteur demande à l'acheteur de saisir son code PIN mobile",
    "errorCode37": "L'acheteur a abandonné la transaction après un paiement sans contact et a été sollicité pour une autre méthode de vérification (PIN or swipe)",
    "errorCode38": "La banque décline la demande d'exemption d'authentification et demande une authentification pour la transaction. Veuillez réessayer le 3D Secure",
    "errorCode39": "The issuer or the scheme wasn't able to communicate the outcome via RReq.",
    "errorCode4": "Transaction interrompue suite à une errreur côté acquisition",
    "errorCode40": "Le réseau de la banque est introuvable. Veuillez réessayer la transaction avec un autre moyen de paiement",
    "errorCode41": "Un code PIN ou une signature est requis.Veuillez réessayer la transaction",
    "errorCode42": "Echec du 3D Secure à cause d'un problème réseau. Veuillez réessayer la transaction ou essayer avec un autre moyen de paiement",
    "errorCode5": "carte bloquée, donc inutilisable",
    "errorCode6": "carte expirée, donc inutilisable",
    "errorCode7": "Montant non conforme pendant la transaction",
    "errorCode8": "numéro de carte invalide",
    "errorCode9": "impossible de contacter la banque de l'acheteur pour l'autorisation"
  },
  "errors": {
    "merchant": {
      "information": "Impossible de récupérer les informations vendeur",
      "products": "Impossible de récupérer les produits du vendeur"
    },
    "categories": "Impossible de charger les catégories",
    "rootCategories": "Impossible de charger les catalogues de catégories",
    "address": {
      "allReadyExist": "L'adresse existe déjà",
      "notFound": "L'adresse n'a pas été trouvée",
      "unauthorized": "Vous n'êtes pas autorisé a créer une adresse."
    },
    "auth": {
      "count": "Code désactivé, veuillez relancer la procédure de connexion pour recevoir un nouveau code | Dernier essai, vous devrez vous authentifier à nouveau | Il vous reste {count} essais ",
      "timeOut": "Le code a expiré",
      "tooMuch": "Trop de tentatives pour ce code",
      "unauthorized": "Code incorrect"
    },
    "billing": {
      "address": "Veuillez ajouter une adresse de facturation"
    },
    "cartAdresse": {
      "allReadyExist": "l'adresse  existe déjà",
      "notFound": "L'adresse n'existe pas",
      "unauthorized": "Changement d'adresse non authorisé",
      "noAddress": "Merci de renseigner une adresse pour obtenir les méthodes de livraison"
    },
    "connexion": "connexion refusée",
    "login": {
      "allReadyExist": "Le compte existe déjà. Veuillez vous connecter ou réinitialiser votre mot de passe à la place",
      "notFound": "Pas de compte pour cette adresse e-mail",
      "unauthorized": "E-mail ou mot de passe invalide, veuillez vérifier vos données"
    },
    "noshipment": "Impossible de calculer les frais de livraison, veuillez réessayer dans quelques minutes et nous contacter si le problème persiste ",
    "notFound": "la ressource n'a pas été trouvée",
    "server": {
      "connexion": "Impossible de se connecter au serveur",
      "access": "Veuillez réessayer dans quelques minutes et nous contacter si le problème persiste",
      "relayAddress": "Vous devez avoir une adresse en France"
    },
    "orders": {
      "notFound": "Pas de commande trouvée"
    },
    "shipmentMethod": {
      "getMethod": {
        "notFound": "Livraison impossible pour cette adresse",
        "addAddress": "Veuillez sélectionner une adresse de livraison"
      },
      "allReadyExist": "Méthode de livraison déjà sélectionnée",
      "notFound": "Méthode de livraison non trouvée",
      "unauthorized": "Méthode de livraison non autorisée"
    },
    "serviceUnavailable": "Une erreur est survenue. Veuillez réessayer plus tard.",
    "noContent": "Pas de contenu renseigné pour cette page.",
    "unauthorized": "Vous n'êtes pas autorisé(e) à faire cette action",
    "not-logged-in": "Votre session a expiré, veuillez vous ré-authentifier."
  },
  "notifications": {
    "coupon": {
      "remove": "Le code promo a été supprimé",
      "add": "Le code promo a été ajouté au panier",
      "allReady": "Le code promo est déjà utilisé",
      "not": "Le code saisi n'existe pas"
    },
    "addToCart": {
      "add": "Le produit {productName} a été ajouté au panier",
      "max": "Quantité maximale atteinte ({stock} en stock) ",
      "remove": "Le produit {productName} a été supprimé du panier",
      "update": "La quantité du produit {productName} a été mise à jour"
    },
    "address": {
      "billing": "l'adresse de facturation par défaut a été mise à jour",
      "created": "Votre adresse a été créée avec succès",
      "removed": "Votre adresse a été supprimée",
      "shipping": "l'adresse de livraison par défaut a été mise à jour",
      "updated": "Votre adresse a été mise à jour"
    }
  },
  "components": {
    "orkRootCategory": {
      "select": {
        "placeholder": "Choisir un catalogue"
      },
      "change": {
        "placeholder": "Changer de catalogue"
      },
      "info": {
        "placeholder": "Vous avez choisi le catalogue :"
      },
      "loading": "Chargement en cours...",
      "title": "Sélectionner un catalogue",
      "description":""
    },
    "orkQuickOrder": {
      "noProduct": "le produit n'a pas été trouvé",
      "title": "Commande rapide",
      "message" : "Scannez le code-barres pour ajouter le produit dans votre panier"
    },
    "orkSocial": {
      "title": "Suivez-nous sur"
    },
    "userAddress": {
      "editAddress": "Modifier l'adresse"
    },
    "orkNewsletter": {
      "title": "Newsletter",
      "subtitle": "Recevez nos actualités et offres personnalisées",
      "validMessage": "Merci de votre intérêt. Vous êtes maintenant inscrit à notre newsletter",
      "errorMailExist": "Vous êtes déjà inscrit à notre newsletter"
    },
    "locations": {
      "loading": "Chargement de la carte"
    },
    "orkProductPreview": {
      "actions": {
        "showProductPage": "Voir la fiche produit"
      }
    },
    "orkRecaptcha": {
      "userTermsHTML": "Ce site est protégé par reCAPTCHA. Les règles de <a class='sf-link' target='_blank' href='https://policies.google.com/privacy'>confidentialité</a> et les <a class='sf-link' target='_blank' href='https://policies.google.com/terms'>conditions d'utilisation</a> de Google s'appliquent.",
      "scoreError": "Le score recaptcha est trop faible",
      "blockerErrorHTML": "Votre navigateur utilise un bloqueur de publicité qui empêche la gestion de vos préférences cookies.<br>Merci de désactiver cette protection afin de pouvoir vous connecter.",
      "cookieMissing": "Ce formulaire nécessite l'utilisation du service reCAPTCHA pour fonctionner.",
      "acceptCookieLink": "Cliquez ici pour accepter les cookies liés au service reCAPTCHA."
    },
    "cardPreview": {
      "shippingCount": "Expédition {count} sur {total}",
      "shippedBy": "expédié par"
    },
    "collectedProduct": {
      "unitPrice": "Prix unitaire",
      "quantity": "Quantité"
    },
    "searchAutocomplete": {
      "no-result": "Pas de resultat trouvé"
    },
    "orkReassurance": {
      "securedPaiement": "Paiement sécurisé",
      "fastDelivery": "Livraison en 72H",
      "localProducts": "Produits locaux",
      "coldChainRespect": "Respect de la chaine du froid",
      "customerCare": "Service après-vente"
    },
    "orkMultiSelect": {
      "placeholder": "Choisir une valeur"
    },
    "orkProductGrid": {
      "filters": {
        "title": "Filtres"
      },
      "actions": {
        "clearFilters": "Reinitialiser les filtres",
        "clearFilter": "Reinitialiser le filtre"
      }
    },
    "orkStock": {
      "productStock": "Plus de stock | <strong>Dernier article en stock</strong> | Article en stock",
      "minimalQty": "Plus que <strong> {quantity} </strong> articles en stock",
      "stockAlert": {
        "text": "Soyez averti lorsque le produit sera en stock.",
        "cta": "Nous contacter"
      }
    },
    "orkProductCart": {
      "configure": {
        "label": "Configurer",
        "arial-label": "Configurer le produit {ProductName}",
        "fromPrice": "à partir de",
        "aria-label": ""
      },
      "addToCart": {
        "label": "Ajouter au panier",
        "notifications": {
          "add": "Le produit {productName} a été ajouté au panier",
          "max": "Quantité maximale atteinte ({stock} en stock) ",
          "remove": "Le produit {productName} supprimé du panier",
          "update": "La quantité du produit {productName} a été mise à jour"
        }
      }
    },
    "okrAddToCart": {
      "quantityLabel": "Quantité",
      "noStock": "Bientôt disponible",
      "addLabel": "Ajouter au panier",
      "modifyLabel": "Modifier la quantité",
      "maxQtyLabel": "Qté max atteinte",
      "isInCartLabel": "Déjà dans le panier",
      "maxQty": "Quantité maximale atteinte",
      "isInCart": "Vous avez déjà <b>{cartQty}</b> unités de cet article dans votre panier"
    },
    "OrkQuantitySelector": {
      "maxQty": "qté<br/>max"
    },
    "modal": {
      "renameOrder": {
        "title": "Renommer la commande",
        "description": "Renommer la commande ne modifie pas sa référence.",
        "hint": "Laisser vide pour utiliser la référence de la commande."
      }
    }
  },
  "pages": {
    "checkout": {
      "payment": {
        "actions": {
          "prev": "Etape précédente"
        },
        "title": "Paiement",
        "tabName": "Paiement",
        "description": "",
        "paymentMethods": {
          "bankTransfer": {
            "title": "Virement bancaire"
          },
          "paypal": {
            "title": "Paypal"
          },
          "card": {
            "title": "Paiement par carte",
            "description": "Le paiement s'effectue sur les serveurs de votre banque. Nous n'avons pas accès à vos données bancaires.",
            "form": {
              "title": "Informations sur la carte",
              "submit": "Payer",
              "loading": "validation du paiement"
            }
          },
          "cgv": {
            "agree": "J'accepte",
            "toTerms": "les conditions générales de vente",
            "seller": " | et celle du vendeur | et celles des vendeurs"
          },
          "billing": {
            "title": "Adresse de facturation",
            "addBtn": "Ajouter une adresse",
            "changeBtn": "Changer l'adresse",
            "chooseBtn": "Choisir une adresse",
            "noAddress": {
              "title": "Veuillez renseigner une adresse"
            }
          }
        }
      },
      "shipping": {
        "title": "Veuillez ajouter une adresse de livraison",
        "tabName": "Livraison",
        "description": "",
        "noAddress": {
          "title": "",
          "actions": {
            "addAddress": "Ajouter une nouvelle adresse"
          },
          "error": "Aucune adresse renseignée"
        },
        "hasAddress": {
          "title": "Merci de sélectionner une adresse de livraison ou d'en ",
          "actions": {
            "createNew": "créer une nouvelle"
          }
        },
        "delivery": {
          "title": "Mode de livraison",
          "shippingCount": "Expédition {count} sur {total}",
          "shippedBy": "expédié par",
          "methods": {
            "title": "Choisissez une méthode d'expédition"
          },
          "estimatedDateHTML": "Date de livraison estimée entre le <b>{startDate}</b> et le <b>{endDate}</b>",
          "": ""
        },
        "actions": {
          "next": "Etape suivante",
          "prev": "Modifier le panier"
        },
        "errors": {
          "noSelectedAddress": "Veuillez sélectionner une adresse de livraison.",
          "noSelectedShipmentMethod": "Veuillez sélectionner une méthode d'expédition pour l'expédition n°{shipmentNr}.",
          "differentRelayAddress": "Veuillez sélectionner le point-relais dans la liste de vos adresses.",
          "unknownError": "Veuillez vérifier vos informations. Si le problème persiste, veuillez nous contacter.",
          "noSelectedRelayAddress": "Veuillez choisir un point-relais pour la méthode d'expédition '{shipmentMethodName}'."
        }
      },
      "thanks": {
        "titleHTML": "Merci pour votre commande",
        "orderRef": "Commande N° : ",
        "text": "Nous allons la préparer dans les meilleurs délais. Vous recevrez bientôt un email de confirmation avec les détails de votre commande.",
        "actions": {
          "home": "Retour à l'accueil",
          "order": "Voir ma commande"
        }
      }
    },
    "products": {
      "focus": {
        "title": "Plus d'information"
      },
      "download": {
        "title": "Documents à télécharger"
      },
      "plusProduct": {
        "title": "Les plus produit"
      },
      "description": {
        "title": "Description"
      },
      "informations": {
        "title": "Informations"
      },
      "characteristics": {
        "title": "Caractéristiques"
      },
      "practice": {
        "title": "En pratique"
      },
      "sku": {
        "label": "Réf."
      },
      "configuration": {
        "placeholder": "Choisir une option"
      },
      "marketPlace": {
        "seller": {
          "title": "Vendu par"
        }
      },
      "addToCart": {
        "productStock": "Bientôt disponible | il ne reste que 1 produit en stock | {count} produits en stock",
        "label": "Ajouter au panier",
        "quantityLabel": "Quantité"
      }
    },
    "401": {
      "description": "Vous n'êtes pas autorisé à afficher cette page",
      "title": "Non autorisé",
      "cta": {
        "back": "Retourner à l'accueil"
      }
    },
    "404": {
      "description": "<p>La page que vous essayez de voir n'existe pas ou a été déplacée.<br/>Essayer de revenir à notre page d'accueil.</p>",
      "title": "Page introuvable",
      "cta": {
        "back": "Retourner à l'accueil"
      }
    },
    "contact": {
      "title": "Besoin d'aide ?",
      "description": ""
    },
    "cms": {
      "error": "Une erreur est survenue. Veuillez réessayer plus tard."
    },
    "home": {
      "bloc": {
        "marketing": {
          "cta": "Découvrir"
        },
        "promotion": {
          "cta": "Toutes les <span>Promos</span>"
        },
        "bestseller": {
          "cta": "Toutes les <span>Offres</span>"
        },
        "categories": {
          "cta": "Découvrez nos catégories"
        }
      }
    },
    "promotions": {
      "noPromotions": "Pas de promotions pour l'instant"
    },
    "seller": {
      "noProducts": "Pas de produit pour ce vendeur"
    },
    "MadeInMayotte": {
      "noProducts": "Pas de produit pour le moment"
    },
    "bestsellers": {
      "noBestsellers": "Pas de meilleurs ventes pour l'instant"
    },
    "resetPassword": {
      "description": "Le mot de passe doit contenir au moins huit caractères, une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial (caractères autorisés : @$!%*?&).",
      "title": "Modifier le mot de passe"
    },
    "search": {
      "placeholder": "Rechercher",
      "titleHasSearch": "Votre terme de recherche: {term}",
      "titleNotSearch": "Commencer votre recherche",
      "notFound": "Pas de résultat trouvé pour le terme :"
    },
    "productList": {
      "filters": {
        "title": "Filtres",
        "boolean": {
          "true": "Oui",
          "false": "Non"
        },
        "from": "de",
        "to": "à",
        "actions": {
          "removeAll": "Supprimer les filtres",
          "confirm": "Valider"
        },
        "scrollElement": {
          "show": "Voir tout",
          "hide": "Cacher"
        }
      },
      "category": {
        "filterLabel":  "Catégories",
        "foundProductsCount": "aucun produit trouvé pour la catégorie | 1 produit trouvé pour la categorie | {count} produits trouvés pour la categorie",
        "noProductFound": "Aucun produit pour cette catégorie"
      },
      "bestsellers": {
        "noProductFound": "Pas de meilleurs ventes pour l'instant"
      },
      "sort": {
        "title": "Trier par",
        "label": "Trier par",
        "placeholder": "Sélectionner le tri"
      },
      "itemPerPage": {
        "title": "Nombre d'articles par page",
        "label": "Nombre d'articles par page"
      },
      "loadingProducts": "Chargement en cours...",
      "foundProductsCount": "Aucun produit trouvé | 1 produit trouvé | {count} produits trouvés",
      "remainingProductsCount": "...encore {currentNumber} sur {totalNumber} produits",
      "noProductFound": "Aucun produit",
      "showMore": "Afficher la suite"
    },
    "myAccount": {
      "title": "Mon compte",
      "description": "",
      "notLogged": "Vous n'êtes pas connecté. Veuillez-vous identifier ou créer un compte.",
      "actions": {
        "signIn": "Je me connecte"
      },
      "logged": {
        "title": "Votre compte"
      },
      "content": {
        "address": {
          "title": "Carnet d'adresses",
          "titleNew": "Ajouter une nouvelle adresse",
          "titleUpdate": "Mettre à jour l'adresse",
          "actions": {
            "goBack": "Retour"
          },
          "manage": {
            "title": "Gérer des adresses",
            "actions": {
              "toggleShipping": "Adresse de livraison par défaut",
              "toggleBilling": "Adresse de facturation par défaut",
              "edit": "Modifier",
              "delete": "Supprimer",
              "add": "Ajouter une nouvelle adresse"
            }
          }
        },
        "informations": {
          "title": "Profil",
          "passwordUpdate": {
            "form": {
              "button": "Valider",
              "newPassword": "Nouveau mot de passe",
              "password": "Mot de passe actuel",
              "repeatPassword": "Confirmer le nouveau mot de passe"
            },
            "notifications": {
              "success": "Le nouveau mot de passe à bien été enregistré !",
              "error": "Les informations du compte n'ont pas été enregistrées !, merci de vérifier vos données ou de nous contacter si le problème persiste"
            },
            "tab": {
              "message": "",
              "title": "Modifier le mot de passe"
            }
          },
          "profileUpdate": {
            "form": {
              "birthDate": "Date de naissance",
              "button": "Valider",
              "email": "Email",
              "firstName": "Prénom",
              "lastName": "Nom",
              "locale": "Choisissez la langue pour les emails de notifications",
              "newsLetterSubscribed": "Inscription à la newsletter",
              "twoFactorAuthenticationEnabled": "Activer la sécurité de votre compte à 2 facteurs"
            },
            "notifications": {
              "success": "Les informations du compte ont bien été enregistrées !",
              "error": ""
            },
            "tab": {
              "message": "",
              "title": "Données personnelles"
            }
          }
        },
        "logout": "Déconnexion",
        "orders": {
          "title": "Commandes",
          "sort": "Trier par",
          "list": {
            "ref": "Référence",
            "date": "Date",
            "amount": "Montant",
            "status": "Statut",
            "actions": {
              "show": "Voir le détail",
              "goHome": "Commencer mon shopping"
            },
            "noOrders": "Aucune commande enregistrée"
          },
          "details": {
            "shippingDetails": {
              "shippingDate": "Expédié le",
              "shippingNumber": "N° de colis",
              "action": "Suivre le colis"
            },
            "backToOrdersList": "Liste des commandes",
            "title": "Détails de la commande",
            "detailsOrder": {
              "amount": "Montant : ",
              "billingAddress": "Adresse de facturation",
              "date": "Date : ",
              "payment": "Paiement",
              "paymentMethod": "Paiement par : ",
              "reference": "Référence : ",
              "shippingAddress": "Adresse de livraison",
              "shippedBy": "expédié par",
              "shippingCount": "Expédition {count} sur {total}"
            },
            "eventHistory": {
              "cancelled": {
                "description": "Votre commande a été annulée",
                "title": "Annulée"
              },
              "pending": {
                "description": "Votre commande est en attente de traitement",
                "title": "En attente"
              },
              "completed": {
                "description": "Votre commande est clôturée",
                "title": "Clôturée"
              },
              "followPackage": "Suivre colis N°",
              "paymentFailed": {
                "description": "Votre paiement a été refusé",
                "title": "Paiement refusé"
              },
              "processing": {
                "description": "Paiement par carte bancaire",
                "title": "Payée"
              },
              "shipped": {
                "description": "Votre commande a été expédiée",
                "title": "Expediée"
              }
            },
            "header": {
              "downloadBill": "Télécharger la facture",
              "from": "du",
              "to": "Date limite de validité :",
              "orderDetails": "Détail de la commande {ref}"
            },
            "priceDetails": {
              "discount": "Réduction",
              "shippingMethodHT": "Frais de livraison HT",
              "vat": "TVA",
              "dockingFees": "Droits de quai",
              "productTotalHT": "Total articles HT",
              "productTotalTTC": "Total articles TTC",
              "subTotalHT": "Sous-total HT",
              "subTotalTTC": "Sous-total TTC",
              "totalHT": "Total HT",
              "totalTTC": "Total TTC"
            },
            "shippmentOrder": {
              "title": "Suivi de votre commande"
            },
            "yourOrder": {
              "quantity": "Quantité : {qty}",
              "title": "Votre commande"
            }
          }
        },
        "wishlist": "Liste d'envies",
        "modal": {
          "personal": {
            "title": {
              "html": "Compte<br/>client",
              "str": "Compte client"
            }
          }
        }
      }
    }
  },
  "breadcrumb": {
    "401": "401",
    "404": "404",
    "home": "Accueil",
    "contact": "Contact",
    "account": "Mon compte",
    "search": "Recherche",
    "category": "Catégorie",
    "promotions": "Promotions",
    "sellers": "Prestataires",
    "help": "Aide",
    "faq": "Questions fréquentes",
    "purchase-guide": "Guide d'achat",
    "who-are-we": "Qui sommes nous ?",
    "become-seller": "Devenir vendeur",
    "exchange": "Echange et retour",
    "legal-mentions": "Mentions légales",
    "gdpr": "Politique de protection des données personnelles",
    "terms-of-sales": "Conditions générales de vente",
    "terms-of-use": "Conditions générales d'utilisation",
    "delivery": "Livraison",
    "bestseller": "Nos offres",
    "made-in-mayotte": "Made In Mayotte"
  },
  "mangoPay": {
    "generic": "Erreur Interne, contacter le support pour connaitre le statut de votre paiement",
    "99999": "Merci de ressayer plus tard ou de nous contacter si le problème persiste.",
    "101301": "l'authentification 3DSecure a échoué",
    "01902": "Cette carte n'est pas active.",
    "02101": "Erreur Interne.",
    "02624": "La carte à expirée.",
    "02625": "Numéro de carte invalide.",
    "02626": "Date invalide. Utiliser le format MMYY.",
    "02627": "Numéro CCV invalide.",
    "02628": "Transaction refusée.",
    "02631": "Délai dépassé.",
    "02632": "La méthode GET n'est pas autorisée.",
    "09101": "Le nom d'utilisateur/mot de passe est incorrect.",
    "09102": "Le compte est verrouillé ou inactif.",
    "09104": "Le certificat client est désactivé.",
    "09201": "Vous n'êtes pas autorisé à effectuer cet appel d'API.",
    "009199": "Les données de votre carte sont invalides ou non prises en charge.",
    "008500": "Ce paiement n'est pas conforme à nos règles anti-fraude. Veuillez nous contacter pour résoudre le problème.",
    "401authorized": "Vous n'êtes pas autorisé à faire cette action.",
    "cardNumber": {
      "error": "Votre N° de carte ne semble pas être correct",
      "required": "N° de carte requis",
      "label": "Numéro de carte"
    },
    "name": {
      "label": "Titulaire de la carte",
      "error": "Votre nom ne semble pas être correct",
      "required": "Nom requis"
    },
    "date": {
      "label": "Date d'expiration (mm/aa)"
    },
    "securityCode": {
      "label": "Code de sécurité"
    },
    "": ""
  },
  "loading": {
    "location": "Chargement des marchands",
    "product": "Chargement des informations produit",
    "categorie": "Chargement des produits",
    "default": "Chargement"
  },
  "priceDetails": {
    "vatAmount": "TVA",
    "taxExclItemsTotal": "Total articles HT",
    "taxInclItemsTotal": "Total articles TTC",
    "taxExclShippingTotal": "Total livraison HT",
    "taxInclShippingTotal": "Total livraison TTC",
    "taxExclOrderTotal": "Total HT",
    "taxInclOrderTotal": "Total TTC",
    "franco": "Plus que <b>{price}</b> pour bénéficier de la livraison gratuite !",
    "francoReached": "Félicitations, vous bénéficiez de la livraison gratuite !"
  },
  " on ": " sur ",
  "2 factors auth": "Connexion à 2 facteurs",
  "48H delivery": "Livraison en 48h",
  "a problem with your order ?": "un problème avec votre commande ?",
  "About us": "A propos de nous",
  "Account already exists": "Le compte existe déjà",
  "accountForm": {
    "authToggle": "<strong>Activer la double authentification</strong> (pour mieux sécuriser votre compte)",
    "birthDate": {
      "error": "date invalide",
      "required": "date requise"
    },
    "email": {
      "error": "Email non valide",
      "required": "Email requis"
    },
    "firstName": {
      "error": "Votre prénom ne semble pas être correct",
      "required": "Prénom requis"
    },
    "lastName": {
      "error": "Votre nom ne semble pas être correct",
      "required": "Nom requis"
    },
    "newPassword": {
      "error": "Mot de passe invalide. Vérifiez les caractères obligatoires et/ou autorisés.",
      "required": "obligatoire"
    },
    "newsletterToggle": "<strong>S'inscrire à la newsletter</strong> (pour recevoir nos actualités & nos promotions)",
    "password": {
      "error": "Mot de passe invalide. Vérifiez les caractères obligatoires et/ou autorisés.",
      "required": "obligatoire"
    },
    "repeatPassword": {
      "error": "les mots de passe ne correspondent pas",
      "required": "obligatoire"
    }
  },
  "Add a billing address": "Ajouter une adresse de facturation",
  "Add new address": "Ajouter une nouvelle adresse",
  "Add the address": "Ajouter l'adresse",
  "Add to cart": "Ajouter au panier",
  "addedProduct": "Vous venez d'ajouter</br><span class='product'> {product}</span>",
  "Address details": "Informations sur l'adresse",
  "Address label": "Nom de l'adresse",
  "Address name is required": "Adresse requise",
  "Address Name": "Nom de l'adresse",
  "addressForm": {
    "city": {
      "error": "Ville non valide",
      "required": "Ville requise"
    },
    "country": {
      "error": "Veuillez renseigner un pays",
      "required": "Pays requis"
    },
    "firstName": {
      "error": "Votre prénom ne semble pas être correct",
      "required": "Prénom requis"
    },
    "lastName": {
      "error": "Votre nom ne semble pas être correct",
      "required": "Nom requis"
    },
    "phone": {
      "error": "Veuillez renseigner un numéro de téléphone valide",
      "required": "Numéro de téléphone requis"
    },
    "postCode": {
      "error": "Le code postal n'est pas valide",
      "required": "Code postal requis"
    },
    "street": {
      "error": "Adresse non valide",
      "required": "Adresse requise"
    }
  },
  "All Orders": "Toutes les commandes",
  "Allow order notifications": "Autoriser les notifications de commande",
  "Amount": "Montant",
  "An error occurred while updating the password": "Une erreur est survenue a la mise à jour de votre mot de passe",
  "An error occurred while updating the profile": "Une erreur s'est produite lors de la mise à jour du profil",
  "Apply": "Appliquer",
  "Back to cart": "retour au panier",
  "back to home": "Retourner à l'accueil",
  "Back to homepage": "Retourner à l'accueil",
  "back to payment": "Retourner au paiement",
  "Back": "Retour",
  "Be notified when we have new stock": "Soyez averti lorsque le produit sera en stock",
  "Be notified": "Rester informé",
  "Become seller": "Devenir vendeur",
  "bestseller": {
    "description": "",
    "title": "##Les plus## demandés"
  },
  "Billing address": "Adresse de facturation",
  "Book a flight": "Acheter un billet",
  "Cancel": "Annuler",
  "CANCELLED": "Annulée",
  "Caractéristiques": "Caractéristiques",
  "Card informations": "Informations de la carte",
  "card Payment": "Paiement par carte",
  "cart": {
    "empty": {
      "message": "Besoin d'idées ?",
      "title": "Votre panier est vide ?!"
    }
  },
  "Categories": "Catégories",
  "category": {
    "label": {
      "bebe": "bebe",
      "electromenager": "electromenager",
      "epicerie": "epicerie",
      "fruits-legumes": "fruitsetlegumes",
      "made-in-mayotte": "madeinmayote",
      "manzaraka": "manzaraka",
      "mode": "mode",
      "quincaillerie": "quincaillerie"
    }
  },
  "Change billing address": "Changer l'adresse de facturation",
  "change my billing address": "Je change mon adresse de facturation",
  "Change password your account": "Changer le mot de passe de votre compte",
  "Change password": "Modifier le mot de passe",
  "Change your personal informations": "Modifier vos informations personnelles",
  "Characteristics": "Caractéristiques",
  "Check my account": "Voir mon compte",
  "Choose a shipping method": "Choisissez une méthode d'expédition",
  "Choose an option": "Choisir une option",
  "Choosen shipping method": "Mode de livraison choisi",
  "City": "Ville",
  "Clear all": "Tout effacer",
  "clearCart": "Vider mon panier",
  "Close": "Fermé",
  "Company": "Société",
  "COMPLETED": "Terminée",
  "configure": "Configurer",
  "Confirm": "Valider",
  "Connexion": "Me connecter",
  "Contact details updated": "Coordonnées mises à jour",
  "Contact Support": "Contacter le support",
  "contact us": "Contacter nous",
  "Contact us": "Nous contacter",
  "contact": "contact",
  "contactForm": {
    "notifications": {
      "success": "Votre message a bien été envoyé. Nous reviendrons vers vous dans les plus brefs délais."
    }
  },
  "Continue Shopping": "Continuer mon shopping",
  "Country": "Pays",
  "coupon code already used": "",
  "coupon code not exist": "",
  "couponTotal": "Réduction {coupon}",
  "Create account": "Nouveau compte",
  "Create an account": "Créer un compte",
  "Create my account": "Créer un nouveau compte",
  "create new address": "créer une nouvelle adresse",
  "create new one": "créer une nouvelle",
  "CREDIT_CARD": "carte de crédit",
  "Current Password": "Mot de passe actuel",
  "Customer service": "Service Client",
  "customerGroup": {
    "description": "Vous êtes connecté avec un compte <b>{customerGroup}</b>",
    "label": {
      "public": "grand public"
    }
  },
  "Date": "Date",
  "Default billing address": "Adresse de facturation par défaut",
  "Default shipping address": "Adresse de livraison par défaut",
  "Delete": "Supprimer",
  "Delivery address": "Adresse de livraison",
  "Delivery options": "Mode de Livraison",
  "Delivery": "Livraison",
  "deliveryTime": {
    "day": " | sous 1 jour | sous {count} jours",
    "hour": " | sous 1 heure | sous {count} heures"
  },
  "Description": "Description",
  "Details and status orders": "Détails et statut des commandes",
  "discount": {
    "description": "",
    "title": "Promotions ##et## ventes flash"
  },
  "Discover our categories": "Découvrez nos catégories",
  "Discover": "Découvrir",
  "discover": "découvrir",
  "Documents to download": "Documents à télécharger",
  "Done": "Fait",
  "Download all": "Tout télécharger",
  "Download": "Télécharger",
  "Echange and return": "Échange et retour",
  "Edit my shopping cart": "Modifier mon panier",
  "Edit": "Modifier",
  "Email has been send to your address with Authentication code, verify your email and type received code": "Un e-mail a été envoyé à votre adresse avec le code d'authentification, vérifiez votre e-mail et saisissez le code reçu",
  "email is required": "E-mail requis",
  "Email": "Email",
  "email": "email",
  "empowerment": {
    "breadcrumb": "Authentification CabinPad",
    "description": "Vous vous apprêtez à passer commande pour le client ci dessous",
    "loading": "Verification des données",
    "title": "Bienvenue dans votre espace cadeau"
  },
  "ENABLE TWO FACTOR AUTH": "ACTIVER LA DOUBLE AUTHENTIFICATION",
  "Enter promo code": "Entrer un code promo",
  "Enter your code": "Saisir un code",
  "Enter your email address to receive a link to reset your password": " Indiquez votre adresse email pour recevoir un lien pour réinitialiser votre mot de passe.",
  "Enter your phone number in case of delivery issue": "Renseignez un numéro de téléphone en cas de problème de livraison",
  "Enter your PNC code": "Saisir votre code PNC",
  "Exchange / Return": "Échange / Retour",
  "Fast delivery 72h*": "Livraison en 72H*",
  "Feedback": "",
  "Filters": "Filtres",
  "Find a relay point near": "Trouver un point relais à proximité de",
  "First name": "Prénom",
  "Firstname is required": "Prénom requis",
  "For more secure access to your account (send a confirmation code by email)": "Pour un accès plus sécurisé de votre compte (envoi d'un code de confirmation par mail)",
  "for": "pour",
  "Forgot password": "Mot de passe oublié",
  "Forgot password?": "Mot de passe oublié ?",
  "Free delivery": "Livraison Gratuite",
  "Free return": "Retour gratuit",
  "free": "gratuit",
  "Free": "GRATUITE",
  "Friday": "Vendredi",
  "Further information": "Informations complémentaires",
  "Get our latest news and best plans": "Pour recevoir nos actualités & nos promotions",
  "gift wrap": "Emballage cadeau",
  "giftcode": "Code carte {coupon}",
  "Go back shopping": "Continuer mes achats",
  "Go back": "Retour",
  "Go to cart": "Voir mon panier",
  "Go to pass order": "Commander",
  "Help": "Aide",
  "hide": "cacher",
  "Home": "Accueil",
  "I agree to": "J'accepte",
  "I crave": "Je craque",
  "I discover": "Je découvre",
  "I log in": "Me connecter",
  "In practice": "En pratique",
  "Info after order": "",
  "Informations": "Informations",
  "Insufficient stock": "Rupture de stock",
  "invalid email": "Email invalide",
  "Item": "Article",
  "items in stock": "articles en stock",
  "Items": "Produits",
  "Last item in stock": "Dernier article en stock",
  "Last Name": "Nom",
  "Last name": "Nom",
  "Lastname is requiered": "",
  "Lastname is required": "Nom requis",
  "Legal mentions": "Mentions légales",
  "Less recent": "Plus ancienne",
  "Let’s start now – we’ll help you": "",
  "Local products": "Produits locaux",
  "locations": {
    "notFound": "Pas de Store"
  },
  "Log in": "Connexion",
  "login in to your account": "Connectez-vous à votre compte",
  "Login or Create an account": "Connexion ou creation de compte",
  "Login": "Mon compte",
  "loginTitle": "Connexion",
  "Looks like you haven’t added any items to the bag yet": {
    " Start shopping to fill it in": {}
  },
  "Looks like you haven’t added any items to the cart yet": "",
  "Make an order": "Faire une commande",
  "Manage addresses": "Gérer les adresses",
  "Menu": "Menu",
  "Message": "Message",
  "Monday": "Lundi",
  "More recent": "Plus récente",
  "More than": "Plus que",
  "My account": "Mon compte",
  "My Cart": "Mon panier",
  "My cart": "Mon panier",
  "My orders": "Mes commandes",
  "My saved address": "Mes adresses sauvegardées",
  "My shopping cart": "Mon panier",
  "myOrders": {
    "order": {
      "backToOrdersList": "Liste des commandes",
      "detailsOrder": {
        "amount": "Montant : ",
        "billingAddress": "Adresse de facturation",
        "date": "Date : ",
        "payment": "Paiement",
        "paymentMethod": "Paiement par : ",
        "reference": "Référence : ",
        "shippingAddress": "Adresse de livraison"
      },
      "eventHistory": {
        "cancelled": {
          "description": "Votre commande a été annulée",
          "title": "Annulée"
        },
        "completed": {
          "description": "Votre commande est clôturée",
          "title": "Clôturée"
        },
        "pending": {
          "description": "Votre commande est en attente de traitement",
          "title": "En attente"
        },
        "followPackage": "Suivre colis N°",
        "paymentFailed": {
          "description": "Votre paiement a été refusé",
          "title": "Paiement refusé"
        },
        "pendingPayment": {
          "description": "Votre commande est en attente de paiement",
          "title": "Paiement en attente"
        },
        "payment": {
          "description": "Votre paiement a été accepté",
          "title": "Paiement"
        },
        "shoppingCart": {
          "description": "Commande passée",
          "title": "Initialisation"
        },
        "processing": {
          "description": "Votre commande est en cours de préparation",
          "title": "En préparation"
        },
        "shipped": {
          "description": "Votre commande a été expédiée",
          "title": "Expediée"
        },
        "partially_shipped": {
          "description": "Votre commande a été partiellement expédiée",
          "title": "Partiellement expediée"
        }
      },
      "payment": {
        "CREDIT_CARD": "Carte de crédit",
        "VISA_MASTERCARD": "Carte Visa / Mastercard",
        "title": "Détail de la transation",
        "date": "Date",
        "reference": "Référence",
        "method": "Methode de paiement"
      },
      "header": {
        "downloadBill": "Télécharger la facture",
        "from": "du",
        "orderDetails": "Détail de la commande {ref}"
      },
      "shippmentOrder": {
        "title": "Suivi de votre commande"
      },
      "yourOrder": {
        "quantity": "Quantité : {qty}",
        "title": "Votre commande"
      },
      "parcelsTracking": {
        "title": "Suivi de vos colis",
        "usage": "Cliquez sur la référence d'un colis pour consulter ses détails",
        "Tracking": "Suivi du colis",
        "SHIPMENT": "Expédition",
        "INFO": "Information",
        "DELIVERY": "Livraison",
        "RETURN": "Retour"
      }
    }
  },
  "myProfile": {
    "passwordUpdate": {
      "form": {
        "button": "Valider",
        "newPassword": "Nouveau mot de passe",
        "password": "Mot de passe actuel",
        "repeatPassword": "Confirmer le nouveau mot de passe"
      },
      "notifications": {
        "success": "Le nouveau mot de passe à bien été enregistré !",
        "error": "Les informations du compte n'ont pas été enregistrées !, merci de vérifier vos données ou de nous contacter si le problème persiste"
      },
      "tab": {
        "message": "Le mot de passe doit contenir au moins huit caractères, une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial (caractères autorisés : @$!%*?&).",
        "title": "Modifier le mot de passe"
      }
    },
    "profileUpdate": {
      "form": {
        "birthDate": "Date de naissance",
        "button": "Valider",
        "email": "Email",
        "firstName": "Prénom",
        "lastName": "Nom",
        "locale": "Choisissez la langue pour les emails de notifications",
        "newsLetterSubscribed": "Inscription à la newsletter",
        "twoFactorAuthenticationEnabled": "Activer la sécurité de votre compte à 2 facteurs"
      },
      "notifications": {
        "success": "Les informations du compte ont bien été enregistrées !",
        "error": "Impossible de mettre a jour vos informations. Veuillez réessayer plus tard. "
      },
      "tab": {
        "message": "",
        "title": "Données personnelles"
      }
    }
  },
  "Name A - Z": "Nom A - Z",
  "Name Z - A": "Nom Z - A",
  "Need Help": "Besoin d'aide",
  "New Password": "Nouveau mot de passe",
  "Newsletter": "Newsletter",
  "Next step": "Etape suivante",
  "No offer for this product": "Aucune offre pour ce produit",
  "No order yet": "Aucune commande enregistrée",
  "No product for this category": "Aucun produit pour cette catégorie",
  "No products found": "Pas de produits trouvés",
  "No result found for term :": "Aucun résultat trouvé pour le terme :",
  "no result found": "pas de resultat trouvé",
  "No saved address": "Aucune adresse sauvegardée",
  "No saved addresses": "Aucune adresse enregistrée",
  "Not a valid Email": "Email invalide",
  "Not Found": "Non trouvé",
  "not found": "Non trouvé",
  "ok": "ok",
  "Opening times": "Horaires d'ouverture",
  "Order ID": "Id de commande",
  "Order N°:": "Commande N° : ",
  "Order reference": "Reference de la commande",
  "Order Returns": "Retours de commande",
  "Order state": "Statut de commande",
  "Order summary": "Récapitulatif de la commande",
  "order": {
    "text": "Nous allons la préparer dans les meilleurs délais. Vous recevrez bientôt un email de confirmation avec les détails de votre commande."
  },
  "ORDERS": "COMMANDES",
  "Our Best Sellers": "Nos meilleures ventes",
  "Our liked product": "Notre coup de coeur",
  "Our universes": "Nos univers",
  "Pass order": "Commander",
  "Pass your order": "Passer commande",
  "password forgot": "Mot de passe oublié",
  "Password": "Mot de passe",
  "Passwords are different": "Les mots de passe sont différents",
  "Pay": "Payer",
  "Payment Error": "Erreur de paiement",
  "Payment in pending": "Paiement en attente",
  "Payment methods": "Mode de paiement",
  "Payment received": "Paiement reçu",
  "Payment Return": "Retour de paiement",
  "Payment": "Paiement",
  "payment": {
    "cancelled": "Paiement annulé",
    "error": "Erreur de paiement",
    "pending": "Paiement en attente",
    "received": "Paiement reçu",
    "refused": "Paiement refusé",
    "unknown": "Erreur inconnue",
    "errors": {
      "missing-billing-address": "Veuillez choisir une adresse de facturation."
    }
  },
  "PAYMENT_FAILED": "Paiement refusé",
  "Personal data": "Données personnelles",
  "Personalized message only": "Message personnalisé uniquement",
  "Personalized message option": "Option message personnalisé",
  "Phone number": "Téléphone",
  "Please add a delivery address": "Veuillez ajouter une adresse de livraison",
  "please add address to select shipping and billing address": "Veuillez ajouter une adresse pour sélectionner l'adresse de livraison et de facturation",
  "Please choose your country": "Merci de choisir un pays",
  "Please contact our customer service :": "Merci de contacter nos services :",
  "Please enter a valid email address": "Merci de saisir une adresse email valide",
  "Please enter your email and password": "Veuillez indiquer votre adresse email ainsi que votre mot de passe.",
  "Please identify yourself to access your customer account": "Veuillez vous identifier pour accéder à votre compte client",
  "Please select a delivery address or ": " Merci de sélectionner une adresse de livraison ou d'en ",
  "Please select your billing address": "Merci de sélectionner votre adresse de facturation",
  "Please type minimum 10 characters and maximum 400": "Le message doit contenir entre 10 et 400 caractères",
  "Please type your city": "Champs ville requis",
  "Please type your last name": "Nom requis",
  "Please type your name": "Prénom requis",
  "Please type your phone number": "Téléphone non valide",
  "Please type your street name": "Adresse requise",
  "Please type your zip code": "code postal requis",
  "Plus product": "Les plus produit",
  "PNC code": "Code PNC",
  "Previous step": "Etape précédente",
  "Price ascending": "Prix croissant",
  "Price descending": "Prix décroissant",
  "Price": "Prix",
  "Primary contacts for any questions": "",
  "Privacy policy": "Politique de protection des données personnelles",
  "PROCESSING": "En cours",
  "product": {
    "relatedProduct": {
      "errorMessage": "Impossible de charger les produits associés !",
      "subTitle": "",
      "title": "Vous aimerez aussi"
    }
  },
  "Products": "Produits",
  "promotions": "promos",
  "Purchase guide": "Guide d'achat",
  "Q&A": "Questions fréquentes",
  "Quantity": "Quantité",
  "Reason for refusal": "Motif de refus",
  "Receives newsletter": "Recevoir la Newsletter",
  "Recevez nos actualités et offres personnalisées": "Recevez nos actualités et offres personnalisées",
  "Recipient": "Destinataire",
  "Reference": "Référence",
  "relay": {
    "change": "Modifier",
    "country": {
      "error": "Ce service de livraison n'est disponible qu'en France",
      "required": ""
    },
    "notFound": "Aucun relais trouvé avec votre adresse, merci de vérifier que l'adresse saisie est correcte",
    "remove": "Supprimer",
    "select": "Choisir",
    "loadingHTML": "Chargement de la liste des points relais en cours...<br/>Merci de patienter"
  },
  "Relevance": "Pertinence",
  "remove all filters": "supprimer les filtres",
  "removedProduct": "Vous venez de retirer</br><span class='product'>{product}</span>",
  "Repeat Password": "Répéter le mot de passe",
  "Reset password": "Réinitialiser mon mot de passe",
  "Reset your password": "Réinitialiser votre mot de passe",
  "Reset": "Effacer",
  "resetpassword": {
    "email": "Si un compte est associé à cette adresse:<strong> {email}</strong>, vous recevrez un email contenant un lien pour réinitialiser votre mot de passe",
    "error": "Erreur lors de la reinitialisation du mot de passe, le lien a expiré merci de recommencer la procédure",
    "valid": "La reinitialisation du mot de passe a bien été prise en compte"
  },
  "Respect of the cold chain": "Respect de la chaine du froid",
  "Go to my account": "Voir mon compte",
  "Same as shipping address": "Identique à l'adresse de livraison",
  "Satisfied or refunded": "Satisfait ou Remboursé",
  "Saturday": "Samedi",
  "Save changes": "Sauvegarder les modifications",
  "search term": "Rechercher",
  "Search": "Rechercher",
  "Secure payment": "Paiement sécurisé",
  "Select sorting": "sélectionner le tri",
  "Select": "Sélectionnez",
  "Sell": "Vendre",
  "Selled by": "Vendu par",
  "sellers": "prestataires",
  "Send my feedback": "",
  "seo": {
    "defaultTitle": "Votre site marchand",
    "defaultDescription": "Facile, rapide et 100% sécurisé !",
    "titlePrefix": "",
    "titleSuffix": " | DEMO",
    "home": {
      "title": "", 
      "description": ""
    },
    "categories": {
      "title": "Catégories",
      "description": "Liste des catégories"
    },
    "lang-category": {
      "title": "Produits par catégorie",
      "description": "Recherche de produits au sein d'une catégorie"
    },
    "product": {
      "title": "Produit",
      "description": "Détail d'un produit"
    },
    "reset-password": {
      "title": "Réinitialisation mot de passe",
      "description": "Réinitialisation du mot de passe"
    },
    "my-account": {
      "title": "Mon compte",
      "description": "Gestion de mon compte personnel",
      "my-profile": {
        "title": "Mon profil",
        "description": "Gestion de mon profil"
      },
      "my-addresses": {
        "title": "Mes adresses",
        "description": "Gestion de mes adresses"
      },
      "my-orders": {
        "title": "Mes commandes",
        "description": "Historique de mes commandes"
      },
      "my-order-details": {
        "title": "Ma commande",
        "description": "Détail d'une commande"
      },
      "log-out": {
        "title": "Déconnexion",
        "description": "Déconnexion de mon compte"
      }
    },
    "checkout": {
      "title": "Finalisez votre commande",
      "description": "Finalisez votre commande",
      "checkout-login": {
        "title": "Connexion",
        "description": "Connectez vous pour pouvoir finaliser votre commande"
      },
      "checkout-shipping": {
        "title": "Livraison",
        "description": "Sélectionnez vos options de livraison"
      },
      "checkout-payment": {
        "title": "Paiement",
        "description": "Paiement de la commande"
      }
    },
    "checkout-payment-result": {
      "title": "Résultat du paiement",
      "description": "Résultat du paiement de la commande"
    },
    "checkout-payment-return": {
      "title": "Redirection en cours",
      "description": "Redirection en cours après paiement"
    },
    "Contact": {
      "title": "Contact",
      "description": "Entrer en contact avec nous"
    },
    "search": {
      "title": "Recherche",
      "description": "Recherche de produits"
    },
    "cart": {
      "title": "Mon panier",
      "description": "Détail du contenu de mon panier"
    },
    "prestataires": {
      "title": "Prestataires",
      "description": "Prestataires"
    },
    "cookies": {
      "title": "Cookies",
      "description": "Politique de gestion des cookies"
    },
    "notfound": {
      "title": "Page introuvable",
      "description": "Page introuvable"
    },
    "notauthorized": {
      "title": "Accès non authorisé",
      "description": "Accès non authorisé à la page demandée"
    }
  },
  "Serveur error, content not found": "Erreur serveur, le contenu n'a pas été touvé",
  "Set as default billing address": "Définir comme adresse de facturation par défaut",
  "Set as default shipping address": "Définir comme adresse de livraison par défaut",
  "Set as default": "Adresse par défaut",
  "Set my cookies parameters": "Modifier mes choix en matière de cookies",
  "shipment ": "livraison ",
  "shipment": "livraison",
  "SHIPPED": "Expediée",
  "Shipping": "Livraison",
  "Show all result": "Voir tout les résultats",
  "Show all": "voir tout",
  "Show detail": "Voir le détail",
  "Show less": "Voir moins",
  "show more": "Afficher la suite",
  "Show more": "Voir plus",
  "Show my order": "Voir ma commande",
  "Show my shopping cart": "Voir mon panier",
  "Show on page": "Nombre d'articles par page",
  "showCategory": "Voir tout l'univers",
  "Sign in": "s'inscrire",
  "sku": "Ref",
  "Sort by": "Trier par",
  "sortBy": "Trier par",
  "Start my shopping": "Commencer mon shopping",
  "Start shopping": "Commencer mon shopping",
  "Start your search": "Commencer votre recherche",
  "Status": "Statut",
  "Street Name": "Rue",
  "Street name": "Rue",
  "Subject": "Sujet",
  "Submit code": "Valider le code",
  "Submit": "Envoyer",
  "SUBSCRIBE NEWSLETTER": "S'INSCRIRE A LA NEWSLETTER",
  "Successful placed order": "Successful placed order",
  "Sunday": "Dimanche",
  "Terms and conditions": "les conditions générales de vente",
  "Terms of sales": "Conditions générales de vente",
  "Terms of use": "Conditions générales d'utilisation",
  "Thank you for your order": "Merci pour votre commande",
  "thank you for your order": "Merci pour votre commande",
  "thanksOrder": "Merci<br/><span class='low'>pour votre commande !</span>",
  "The password has been updated": "Votre mot de passe a été mise à jour",
  "The profile has been updated": "Vos informations personnelles ont été mise à jour",
  "These products are out of stock :": "Ces produits ne sont plus en stock",
  "this code is valid 10min": "Ce code de validation est valable 10min",
  "This product is out of stock :": "Ce produit n'est plus en stock",
  "Thursday": "Jeudi",
  "Too late": "Trop tard",
  "Total price ": "Tarif total",
  "Total shipping price": "Tarif de livraison",
  "Total": "Total",
  "Transaction reference": "Référence de la transaction",
  "Tuesday": "Mardi",
  "twoFactor": {
    "description": "Un e-mail vous a été envoyé avec un code de validation. Consultez votre email et saisissez ci-dessous le code reçu. \n(le code est valable 10 min)",
    "title": "Connexion à deux facteurs"
  },
  "type a message": "Ecrire un message",
  "Unable to load bestseller": "Impossible de charger les meilleurs ventes",
  "Unit price ": "Prix unitaire",
  "Update address": "Mettre à jour l'adresse",
  "Update": "Mettre à jour",
  "Validate my order": "Valider ma commande",
  "Validate": "Valider",
  "View details": "Voir le détail",
  "Wednesday": "Mercredi",
  "Welcome": "Bienvenue",
  "WelcomeMessage": "Bienvenue<br><span class='customer'><span class='firstname'>{firstName}</span> <span class='lastname'>{lastName}</span></span>",
  "TermOf": "Conditions générales de ventes de {shopName}",
  "What can we improve": "",
  "Where to find us": "Où nous trouver",
  "Who are we ?": "Qui sommes nous ?",
  "Who are we": "Qui sommes nous",
  "With gift wrap": "avec emballage cadeau",
  "You are not logged, sign-in or create an account": "Vous n'êtes pas connecté. Veuillez-vous identifier ou créer un compte.",
  "You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below": "Vous pouvez contacter le support si vous voulez plus d'explication en mentionnant le refus et la reference de la transaction ci dessous",
  "You currently have no orders": "Vous n'avez actuellement aucune commande",
  "You have a gift card ?": "Vous avez une carte cadeau ?",
  "You have a promotional code ?": "Vous avez un code promotionnel ?",
  "You haven’t searched for items yet": "Vous n'avez pas encore recherché d'articles",
  "Your account": "Mon compte",
  "Your cart is empty": "Votre panier est vide",
  "Your cart": "Mon panier",
  "Your coupon code": "Code promotionnel",
  "your email": "Votre email",
  "Your name should have at least one character": "Votre nom doit contenir au moins un caractère",
  "Your order": "Votre Commande",
  "Your password must contain eight characters, at least one uppercase letter, one lowercase letter, one number and one special character": "Le mot de passe doit au moins contenir huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial",
  "Your Purchase": "Votre commande",
  "Your search term : {term}": "Votre terme recherche : {term}",
  "Your shipping address": "Votre adresse de livraison",
  "Zip-code": "Code postal",
  "Zipcode should have only numbers": "Code postal invalide",
  "No product for this seller": "Aucun produit pour ce vendeur",
  "yes": "oui",
  "no": "non",
  "page": {
    "promotions": {
      "title": "Promotions",
      "description": ""
    },
    "madeInMayotte": {
      "title": "Made in Mayotte",
      "description": ""
    },
    "bestSeller": {
      "title": "Nos meilleurs offres",
      "description": ""
    }
  },
  "No promotions": "pas de promotions pour l'instant",
  "No bestseller": "pas d'offres' pour l'instant",
  "Category": "Catégorie",
  "Product": "Produit",
  "Tracking": "Suivi",
  "Pickup code": "Code de retrait",
  "shipmentOption": {
    "price": {
      "free": "Gratuit"
    }
  },
  "orderSummary": {
    "title": "Récapitulatif",
    "priceLine": {
      "coupon": "Code promo"
    }
  },
  "config": {
    "taxMode": {
      "taxFree": "HT",
      "taxIncluded": "TTC"
    }
  },
  "Label": "Nom",
  "psp.systempay.paymentMethod.PAYPAL_BNPL.label": "PayPal - Payez en 4 fois"
}
